<template>
  <ol class="breadcrumb" v-if="getUserData.level_access >= 2">
    <li>
      <router-link
        :to="{ name: 'Verticals' }"
        title="Principal"
      >
        Principal
      </router-link>
    </li>

    <li v-for="(item, index) in items" :key="index">
      <router-link
        v-if="item.routeName"
        :to="{ name: item.routeName }"
        title="Principal"
      >
        {{ item.title }}
      </router-link>

      <strong v-else-if="index === items.length - 1">{{ item.title }}</strong>

      <span v-else>{{ item.title }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getUserData () {
      const { userData } = this.$store.state
      return userData
    }
  }
}
</script>

<style scoped>
.breadcrumb a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/Breadcrumb.vue